import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Badge,
  Switch,
  FormControlLabel,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Add as AddIcon,
  LocalOffer as DiscountIcon,
  Info as InfoIcon,
  Refresh as RefreshIcon,
  Visibility as ViewIcon,
  QrCode2 as CouponIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Percent as PercentIcon,
  AttachMoney as MoneyIcon,
  ShoppingCart as CartIcon,
  People as PeopleIcon,
  CalendarToday as CalendarIcon,
  TrendingUp as TrendingUpIcon,
  CardGiftcard as GiftIcon,
  Redeem as RedeemIcon,
} from "@mui/icons-material";

const DiscountMaster = () => {
  const [discountData, setDiscountData] = useState([
    { 
      id: 1, 
      discountCode: "WELCOME10",
      discountName: "Welcome Offer 10%", 
      discountType: "Percentage",
      discountValue: 10,
      minPurchase: 500,
      maxDiscount: 100,
      applicableOn: "All Products",
      customerType: "New Customers",
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      usageLimit: 1000,
      usedCount: 245,
      description: "Welcome discount for new customers",
      status: "Active",
      isStackable: false,
      requiresCoupon: true,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 2, 
      discountCode: "FLAT500",
      discountName: "Flat ₹500 Off", 
      discountType: "Fixed Amount",
      discountValue: 500,
      minPurchase: 2000,
      maxDiscount: 500,
      applicableOn: "All Products",
      customerType: "All Customers",
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      usageLimit: 5000,
      usedCount: 1850,
      description: "Flat ₹500 discount on orders above ₹2000",
      status: "Active",
      isStackable: false,
      requiresCoupon: true,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 3, 
      discountCode: "MEMBER20",
      discountName: "Member Exclusive 20%", 
      discountType: "Percentage",
      discountValue: 20,
      minPurchase: 1000,
      maxDiscount: 500,
      applicableOn: "Selected Categories",
      customerType: "Members",
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      usageLimit: 0,
      usedCount: 892,
      description: "Exclusive discount for loyalty members",
      status: "Active",
      isStackable: false,
      requiresCoupon: true,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 4, 
      discountCode: "SUMMER30",
      discountName: "Summer Sale 30%", 
      discountType: "Percentage",
      discountValue: 30,
      minPurchase: 0,
      maxDiscount: 1000,
      applicableOn: "Selected Products",
      customerType: "All Customers",
      validFrom: "2024-06-01",
      validTo: "2024-08-31",
      usageLimit: 10000,
      usedCount: 4567,
      description: "Summer seasonal discount",
      status: "Active",
      isStackable: false,
      requiresCoupon: false,
      createdDate: "2024-05-01",
      updatedDate: "2024-05-01"
    },
    { 
      id: 5, 
      discountCode: "BOGO",
      discountName: "Buy 1 Get 1", 
      discountType: "BOGO",
      discountValue: 50,
      minPurchase: 0,
      maxDiscount: 0,
      applicableOn: "Selected Products",
      customerType: "All Customers",
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      usageLimit: 2000,
      usedCount: 678,
      description: "Buy one get one free offer",
      status: "Active",
      isStackable: false,
      requiresCoupon: false,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 6, 
      discountCode: "BULK15",
      discountName: "Bulk Purchase 15%", 
      discountType: "Percentage",
      discountValue: 15,
      minPurchase: 5000,
      maxDiscount: 2000,
      applicableOn: "All Products",
      customerType: "Wholesale",
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      usageLimit: 0,
      usedCount: 234,
      description: "Discount for bulk purchases",
      status: "Active",
      isStackable: true,
      requiresCoupon: false,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 7, 
      discountCode: "FLASH40",
      discountName: "Flash Sale 40%", 
      discountType: "Percentage",
      discountValue: 40,
      minPurchase: 0,
      maxDiscount: 1500,
      applicableOn: "Selected Products",
      customerType: "All Customers",
      validFrom: "2024-03-15",
      validTo: "2024-03-16",
      usageLimit: 500,
      usedCount: 500,
      description: "24-hour flash sale",
      status: "Expired",
      isStackable: false,
      requiresCoupon: true,
      createdDate: "2024-03-01",
      updatedDate: "2024-03-16"
    },
    { 
      id: 8, 
      discountCode: "VIP25",
      discountName: "VIP Special 25%", 
      discountType: "Percentage",
      discountValue: 25,
      minPurchase: 0,
      maxDiscount: 3000,
      applicableOn: "All Products",
      customerType: "VIP",
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      usageLimit: 0,
      usedCount: 156,
      description: "Exclusive VIP customer discount",
      status: "Active",
      isStackable: false,
      requiresCoupon: false,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 9, 
      discountCode: "FIRST100",
      discountName: "First Order ₹100 Off", 
      discountType: "Fixed Amount",
      discountValue: 100,
      minPurchase: 500,
      maxDiscount: 100,
      applicableOn: "All Products",
      customerType: "New Customers",
      validFrom: "2024-01-01",
      validTo: "2024-12-31",
      usageLimit: 0,
      usedCount: 1234,
      description: "First purchase discount",
      status: "Active",
      isStackable: false,
      requiresCoupon: true,
      createdDate: "2024-01-01",
      updatedDate: "2024-01-01"
    },
    { 
      id: 10, 
      discountCode: "CLEAR50",
      discountName: "Clearance 50% Off", 
      discountType: "Percentage",
      discountValue: 50,
      minPurchase: 0,
      maxDiscount: 5000,
      applicableOn: "Selected Products",
      customerType: "All Customers",
      validFrom: "2024-02-01",
      validTo: "2024-02-29",
      usageLimit: 0,
      usedCount: 0,
      description: "End of season clearance",
      status: "Inactive",
      isStackable: false,
      requiresCoupon: false,
      createdDate: "2024-01-15",
      updatedDate: "2024-01-15"
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [typeFilter, setTypeFilter] = useState("all");
  const [customerFilter, setCustomerFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Modal state
  const [openModal, setOpenModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [editingDiscount, setEditingDiscount] = useState(null);
  const [viewingDiscount, setViewingDiscount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [newDiscount, setNewDiscount] = useState({
    discountCode: "",
    discountName: "",
    discountType: "Percentage",
    discountValue: 0,
    minPurchase: 0,
    maxDiscount: 0,
    applicableOn: "All Products",
    customerType: "All Customers",
    validFrom: "",
    validTo: "",
    usageLimit: 0,
    description: "",
    status: "Active",
    isStackable: false,
    requiresCoupon: true,
  });

  // Get unique values for filters
  const discountTypes = [...new Set(discountData.map(d => d.discountType))];
  const customerTypes = [...new Set(discountData.map(d => d.customerType))];

  // Helper functions
  const getFilteredDiscounts = () => {
    return discountData.filter((discount) => {
      const matchesSearch = Object.values(discount).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesStatus = statusFilter === "all" || discount.status === statusFilter;
      const matchesType = typeFilter === "all" || discount.discountType === typeFilter;
      const matchesCustomer = customerFilter === "all" || discount.customerType === customerFilter;
      return matchesSearch && matchesStatus && matchesType && matchesCustomer;
    });
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Active':
        return { backgroundColor: '#e8f5e9', color: '#2e7d32' };
      case 'Expired':
        return { backgroundColor: '#ffebee', color: '#d32f2f' };
      case 'Inactive':
        return { backgroundColor: '#fff3e0', color: '#e65100' };
      default:
        return { backgroundColor: '#f5f5f5', color: '#666' };
    }
  };

  const getTypeColor = (type) => {
    switch (type) {
      case 'Percentage': return 'primary';
      case 'Fixed Amount': return 'secondary';
      case 'BOGO': return 'success';
      case 'Free Shipping': return 'info';
      default: return 'default';
    }
  };

  const getCustomerColor = (customerType) => {
    switch (customerType) {
      case 'All Customers': return 'primary';
      case 'New Customers': return 'success';
      case 'Members': return 'info';
      case 'VIP': return 'error';
      case 'Wholesale': return 'warning';
      default: return 'default';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newDiscount.discountCode.trim()) newErrors.discountCode = 'Discount code is required';
    if (!newDiscount.discountName.trim()) newErrors.discountName = 'Discount name is required';
    if (!newDiscount.discountType.trim()) newErrors.discountType = 'Discount type is required';
    if (newDiscount.discountValue === undefined || newDiscount.discountValue <= 0) {
      newErrors.discountValue = 'Discount value must be greater than 0';
    }
    if (!newDiscount.validFrom) newErrors.validFrom = 'Valid from date is required';
    if (!newDiscount.validTo) newErrors.validTo = 'Valid to date is required';
    if (newDiscount.validFrom && newDiscount.validTo && newDiscount.validFrom > newDiscount.validTo) {
      newErrors.validTo = 'Valid to date must be after valid from date';
    }
    return newErrors;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  // Handlers
  const handleEdit = (discount) => {
    setEditingDiscount(discount);
    setNewDiscount({ ...discount });
    setOpenModal(true);
  };

  const handleView = (discount) => {
    setViewingDiscount(discount);
    setOpenViewModal(true);
  };

  const handleDelete = (id) => {
    const discountToDelete = discountData.find(d => d.id === id);
    
    if (discountToDelete.usedCount > 0) {
      if (!window.confirm(`This discount has been used ${discountToDelete.usedCount} times. Are you sure you want to delete it?`)) {
        return;
      }
    }

    if (window.confirm("Are you sure you want to delete this discount?")) {
      setDiscountData(discountData.filter((discount) => discount.id !== id));
      setSuccessMessage("Discount deleted successfully!");
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredDiscounts().length} discounts.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setStatusFilter("all");
    setTypeFilter("all");
    setCustomerFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenModal = () => {
    setEditingDiscount(null);
    setNewDiscount({
      discountCode: "",
      discountName: "",
      discountType: "Percentage",
      discountValue: 0,
      minPurchase: 0,
      maxDiscount: 0,
      applicableOn: "All Products",
      customerType: "All Customers",
      validFrom: "",
      validTo: "",
      usageLimit: 0,
      description: "",
      status: "Active",
      isStackable: false,
      requiresCoupon: true,
    });
    setErrors({});
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setEditingDiscount(null);
    setErrors({});
  };

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setViewingDiscount(null);
  };

  const handleInputChange = (e) => {
    const { name, value, checked, type } = e.target;
    setNewDiscount({ 
      ...newDiscount, 
      [name]: type === 'checkbox' ? checked : value 
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const handleAddDiscount = async () => {
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setIsLoading(true);
    try {
      if (editingDiscount) {
        setDiscountData(discountData.map(discount => 
          discount.id === editingDiscount.id 
            ? { 
                ...discount, 
                ...newDiscount,
                discountValue: parseFloat(newDiscount.discountValue),
                minPurchase: parseFloat(newDiscount.minPurchase),
                maxDiscount: parseFloat(newDiscount.maxDiscount),
                usageLimit: parseInt(newDiscount.usageLimit),
                updatedDate: new Date().toISOString().split('T')[0]
              }
            : discount
        ));
        setSuccessMessage("Discount updated successfully!");
      } else {
        const newId = discountData.length > 0 ? Math.max(...discountData.map(d => d.id)) + 1 : 1;
        setDiscountData([...discountData, { 
          id: newId, 
          ...newDiscount,
          discountValue: parseFloat(newDiscount.discountValue),
          minPurchase: parseFloat(newDiscount.minPurchase),
          maxDiscount: parseFloat(newDiscount.maxDiscount),
          usageLimit: parseInt(newDiscount.usageLimit),
          usedCount: 0,
          createdDate: new Date().toISOString().split('T')[0],
          updatedDate: new Date().toISOString().split('T')[0]
        }]);
        setSuccessMessage("Discount added successfully!");
      }
      handleCloseModal();
    } catch (error) {
      setErrors({ general: "An error occurred. Please try again." });
    } finally {
      setIsLoading(false);
      setTimeout(() => setSuccessMessage(""), 3000);
    }
  };

  const filteredDiscounts = getFilteredDiscounts();

  // Calculate statistics
  const totalDiscounts = discountData.length;
  const activeDiscounts = discountData.filter(d => d.status === "Active").length;
  const totalUsage = discountData.reduce((sum, discount) => sum + discount.usedCount, 0);
  const avgUsage = totalUsage / totalDiscounts;

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Badge badgeContent={totalDiscounts} color="primary">
            <DiscountIcon sx={{ color: 'primary.main', fontSize: 40 }} />
          </Badge>
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Discount Master Management
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Manage promotional discounts and coupon codes • {filteredDiscounts.length} discounts found
            </Typography>
          </Box>
        </Box>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            backgroundColor: 'primary.main',
            '&:hover': {
              backgroundColor: 'primary.dark',
            },
          }}
        >
          Add New Discount
        </Button>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Search and Filter Section */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              label="Search Discounts..."
              variant="outlined"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Type"
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Types</option>
              {discountTypes.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Customer"
              value={customerFilter}
              onChange={(e) => setCustomerFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All</option>
              {customerTypes.map((type) => (
                <option key={type} value={type}>{type}</option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <TextField
              select
              fullWidth
              label="Status"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              SelectProps={{
                native: true,
              }}
            >
              <option value="all">All Status</option>
              <option value="Active">Active</option>
              <option value="Expired">Expired</option>
              <option value="Inactive">Inactive</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                variant="contained"
                onClick={handleSearch}
                startIcon={<SearchIcon />}
                sx={{ flex: 1 }}
              >
                Search
              </Button>
              <Button
                variant="outlined"
                onClick={handleReset}
                startIcon={<RefreshIcon />}
                sx={{ flex: 1 }}
              >
                Reset
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>S.No</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Code</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Discount Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Value</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Customer Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Usage</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Validity</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '0.95rem' }} align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDiscounts.length > 0 ? (
                filteredDiscounts
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((discount, index) => (
                    <TableRow 
                      key={discount.id} 
                      sx={{ 
                        '&:hover': { backgroundColor: '#f5f5f5' },
                        transition: 'background-color 0.2s'
                      }}
                    >
                      <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CouponIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                          <Typography variant="body2" fontWeight="600" sx={{ fontFamily: 'monospace' }}>
                            {discount.discountCode}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2" fontWeight="600">
                          {discount.discountName}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={discount.discountType} 
                          size="small" 
                          color={getTypeColor(discount.discountType)}
                          sx={{ fontWeight: 500 }}
                        />
                      </TableCell>
                      <TableCell>
                        {discount.discountType === 'Percentage' ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <PercentIcon sx={{ fontSize: 16, color: 'success.main' }} />
                            <Typography variant="body2" fontWeight="600" color="success.main">
                              {discount.discountValue}%
                            </Typography>
                          </Box>
                        ) : discount.discountType === 'Fixed Amount' ? (
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            <MoneyIcon sx={{ fontSize: 16, color: 'info.main' }} />
                            <Typography variant="body2" fontWeight="600" color="info.main">
                              {formatCurrency(discount.discountValue)}
                            </Typography>
                          </Box>
                        ) : (
                          <Typography variant="body2" fontWeight="600" color="warning.main">
                            {discount.discountValue}%
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell>
                        <Chip 
                          label={discount.customerType} 
                          size="small" 
                          color={getCustomerColor(discount.customerType)}
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Typography variant="caption" fontWeight="600" color="primary.main">
                            {discount.usedCount} used
                          </Typography>
                          {discount.usageLimit > 0 && (
                            <Typography variant="caption" color="text.secondary">
                              of {discount.usageLimit}
                            </Typography>
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                          <Typography variant="caption">
                            {discount.validFrom}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            to {discount.validTo}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={discount.status}
                          size="small"
                          sx={{
                            ...getStatusStyle(discount.status),
                            fontWeight: 600,
                            fontSize: '0.75rem'
                          }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                          <Tooltip title="View Details">
                            <IconButton
                              size="small"
                              onClick={() => handleView(discount)}
                              sx={{
                                color: 'info.main',
                                '&:hover': {
                                  backgroundColor: 'info.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <ViewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit Discount">
                            <IconButton
                              size="small"
                              onClick={() => handleEdit(discount)}
                              sx={{
                                color: 'warning.main',
                                '&:hover': {
                                  backgroundColor: 'warning.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete Discount">
                            <IconButton
                              size="small"
                              onClick={() => handleDelete(discount.id)}
                              sx={{
                                color: 'error.main',
                                '&:hover': {
                                  backgroundColor: 'error.light',
                                  transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s'
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell colSpan={10} align="center" sx={{ py: 4 }}>
                    <DiscountIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 1 }} />
                    <Typography variant="body1" color="text.secondary">
                      No discounts found
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Try adjusting your search criteria or add a new discount.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={filteredDiscounts.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
      </Paper>

      {/* Add/Edit Discount Modal */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <DiscountIcon />
            {editingDiscount ? 'Edit Discount' : 'Add New Discount'}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Discount Code"
                name="discountCode"
                value={newDiscount.discountCode}
                onChange={handleInputChange}
                error={!!errors.discountCode}
                helperText={errors.discountCode || "e.g., WELCOME10, FLAT500"}
                required
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CouponIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Discount Name"
                name="discountName"
                value={newDiscount.discountName}
                onChange={handleInputChange}
                error={!!errors.discountName}
                helperText={errors.discountName}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth error={!!errors.discountType}>
                <InputLabel>Discount Type *</InputLabel>
                <Select
                  name="discountType"
                  value={newDiscount.discountType}
                  onChange={handleInputChange}
                  label="Discount Type *"
                >
                  <MenuItem value="Percentage">Percentage Discount</MenuItem>
                  <MenuItem value="Fixed Amount">Fixed Amount Off</MenuItem>
                  <MenuItem value="BOGO">Buy One Get One</MenuItem>
                  <MenuItem value="Free Shipping">Free Shipping</MenuItem>
                </Select>
                {errors.discountType && <Typography variant="caption" color="error">{errors.discountType}</Typography>}
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label={newDiscount.discountType === 'Percentage' ? 'Discount %' : 'Discount Amount'}
                name="discountValue"
                type="number"
                value={newDiscount.discountValue}
                onChange={handleInputChange}
                error={!!errors.discountValue}
                helperText={errors.discountValue}
                required
                inputProps={{ min: 0, step: newDiscount.discountType === 'Percentage' ? 0.1 : 1 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {newDiscount.discountType === 'Percentage' ? <PercentIcon /> : <MoneyIcon />}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Minimum Purchase Amount"
                name="minPurchase"
                type="number"
                value={newDiscount.minPurchase}
                onChange={handleInputChange}
                inputProps={{ min: 0 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CartIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Maximum Discount Cap"
                name="maxDiscount"
                type="number"
                value={newDiscount.maxDiscount}
                onChange={handleInputChange}
                helperText="0 = No limit"
                inputProps={{ min: 0 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MoneyIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Applicable On</InputLabel>
                <Select
                  name="applicableOn"
                  value={newDiscount.applicableOn}
                  onChange={handleInputChange}
                  label="Applicable On"
                >
                  <MenuItem value="All Products">All Products</MenuItem>
                  <MenuItem value="Selected Products">Selected Products</MenuItem>
                  <MenuItem value="Selected Categories">Selected Categories</MenuItem>
                  <MenuItem value="Selected Brands">Selected Brands</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Customer Type</InputLabel>
                <Select
                  name="customerType"
                  value={newDiscount.customerType}
                  onChange={handleInputChange}
                  label="Customer Type"
                >
                  <MenuItem value="All Customers">All Customers</MenuItem>
                  <MenuItem value="New Customers">New Customers Only</MenuItem>
                  <MenuItem value="Members">Members Only</MenuItem>
                  <MenuItem value="VIP">VIP Customers</MenuItem>
                  <MenuItem value="Wholesale">Wholesale Customers</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Valid From"
                name="validFrom"
                type="date"
                value={newDiscount.validFrom}
                onChange={handleInputChange}
                error={!!errors.validFrom}
                helperText={errors.validFrom}
                required
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Valid To"
                name="validTo"
                type="date"
                value={newDiscount.validTo}
                onChange={handleInputChange}
                error={!!errors.validTo}
                helperText={errors.validTo}
                required
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Usage Limit"
                name="usageLimit"
                type="number"
                value={newDiscount.usageLimit}
                onChange={handleInputChange}
                helperText="0 = Unlimited"
                inputProps={{ min: 0 }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={newDiscount.status}
                  onChange={handleInputChange}
                  label="Status"
                >
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                  <MenuItem value="Expired">Expired</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newDiscount.requiresCoupon}
                    onChange={handleInputChange}
                    name="requiresCoupon"
                    color="primary"
                  />
                }
                label="Requires Coupon"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControlLabel
                control={
                  <Switch
                    checked={newDiscount.isStackable}
                    onChange={handleInputChange}
                    name="isStackable"
                    color="warning"
                  />
                }
                label="Can be stacked with other offers"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Description"
                name="description"
                value={newDiscount.description}
                onChange={handleInputChange}
                multiline
                rows={3}
                placeholder="Enter discount description..."
              />
            </Grid>
          </Grid>
          {errors.general && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {errors.general}
            </Alert>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseModal} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleAddDiscount}
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={20} /> : <AddIcon />}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            {isLoading ? 'Processing...' : (editingDiscount ? 'Update Discount' : 'Add Discount')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Discount Modal */}
      <Dialog open={openViewModal} onClose={handleCloseViewModal} maxWidth="md" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
          padding: '16px 24px',
        }}>
          <Typography variant="h6" component="div" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon />
            Discount Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: '24px', mt: 2 }}>
          {viewingDiscount && (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Avatar 
                    sx={{ 
                      width: 80, 
                      height: 80, 
                      margin: '0 auto',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    <GiftIcon sx={{ fontSize: 40 }} />
                  </Avatar>
                  <Typography variant="h5" sx={{ mt: 2, fontWeight: 'bold' }}>
                    {viewingDiscount.discountName}
                  </Typography>
                  <Chip 
                    label={viewingDiscount.discountCode}
                    sx={{ 
                      mt: 1,
                      fontWeight: 600,
                      fontSize: '0.9rem',
                      fontFamily: 'monospace',
                      backgroundColor: 'primary.light',
                      color: 'primary.dark'
                    }}
                  />
                </Box>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Discount Type</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip 
                      label={viewingDiscount.discountType} 
                      color={getTypeColor(viewingDiscount.discountType)}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Discount Value</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    {viewingDiscount.discountType === 'Percentage' ? (
                      <>
                        <PercentIcon sx={{ color: 'success.main' }} />
                        <Typography variant="body1" fontWeight="bold" color="success.main">
                          {viewingDiscount.discountValue}%
                        </Typography>
                      </>
                    ) : (
                      <>
                        <MoneyIcon sx={{ color: 'info.main' }} />
                        <Typography variant="body1" fontWeight="bold" color="info.main">
                          {formatCurrency(viewingDiscount.discountValue)}
                        </Typography>
                      </>
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Minimum Purchase</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingDiscount.minPurchase > 0 ? formatCurrency(viewingDiscount.minPurchase) : 'No Minimum'}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Maximum Discount Cap</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingDiscount.maxDiscount > 0 ? formatCurrency(viewingDiscount.maxDiscount) : 'No Limit'}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Applicable On</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingDiscount.applicableOn}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Customer Type</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip 
                      label={viewingDiscount.customerType} 
                      color={getCustomerColor(viewingDiscount.customerType)}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Valid From</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <CalendarIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingDiscount.validFrom}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Valid To</Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                    <CalendarIcon sx={{ color: 'primary.main' }} />
                    <Typography variant="body1" fontWeight="bold">
                      {viewingDiscount.validTo}
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Usage Statistics</Typography>
                  <Typography variant="body1" fontWeight="bold" color="primary">
                    {viewingDiscount.usedCount} times used
                    {viewingDiscount.usageLimit > 0 && ` of ${viewingDiscount.usageLimit}`}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Coupon Required</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingDiscount.requiresCoupon ? (
                      <Chip icon={<CheckCircleIcon />} label="Yes" color="success" />
                    ) : (
                      <Chip icon={<CancelIcon />} label="No" />
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Stackable</Typography>
                  <Box sx={{ mt: 1 }}>
                    {viewingDiscount.isStackable ? (
                      <Chip icon={<CheckCircleIcon />} label="Yes" color="warning" />
                    ) : (
                      <Chip icon={<CancelIcon />} label="No" />
                    )}
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Status</Typography>
                  <Box sx={{ mt: 1 }}>
                    <Chip
                      label={viewingDiscount.status}
                      sx={{
                        ...getStatusStyle(viewingDiscount.status),
                        fontWeight: 600,
                      }}
                    />
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Description</Typography>
                  <Typography variant="body1" sx={{ mt: 1 }}>
                    {viewingDiscount.description || 'No description available'}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Created Date</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingDiscount.createdDate}
                  </Typography>
                </Paper>
              </Grid>
              
              <Grid item xs={12} sm={6}>
                <Paper sx={{ p: 2, backgroundColor: 'rgba(144, 19, 254, 0.05)' }}>
                  <Typography variant="caption" color="text.secondary">Last Updated</Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {viewingDiscount.updatedDate}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button onClick={handleCloseViewModal}>Close</Button>
          {viewingDiscount && (
            <Button
              variant="contained"
              onClick={() => {
                handleCloseViewModal();
                handleEdit(viewingDiscount);
              }}
              startIcon={<EditIcon />}
              sx={{
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              Edit Discount
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default DiscountMaster;

